<div class="container-fluid d-print-none">
    <div class="row">
        <div class="col px-md-8">
            <div class="nav-bar d-flex flex-row align-items-center justify-content-between">
                <ui-submenu class="py-1" [menuItems]="items" [privs]="privs$ | async" />
                <div class="tools-controls d-flex flex-row flex-nowrap align-items-center">
                    @if (user$ | async) {
                        <ui-clock class="me-3" [time]="databaseTime$ | async" />
                    }

                    <ui-export-control class="me-3" />
                    <ui-print-control />
                </div>
            </div>
        </div>
    </div>
</div>
